__webpack_require__.p = "https://svso.test.perfectstay.io/static/";